// Kamera okumasını teyit eder: aynı değer `need` kez `windowMs` içinde okunursa kabul; kabul sonrası `cooldownMs` aynı değer yok sayılır.
export function createScanConfirm({ need = 3, windowMs = 1200, cooldownMs = 1500, now = () => Date.now() } = {}) {
  let cur = { code: "", n: 0, first: 0 };
  let last = { code: "", at: -Infinity };
  return (raw) => {
    const code = String(raw || "").trim();
    const t = now();
    if (!code || (code === last.code && t - last.at < cooldownMs)) return null;
    if (code !== cur.code || t - cur.first > windowMs) cur = { code, n: 0, first: t };
    cur.n += 1;
    if (cur.n < need) return null;
    last = { code, at: t };
    cur = { code: "", n: 0, first: 0 };
    return code;
  };
}
